// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Dashboard Styles - Dark theme (matches IdP design system)
 */

.dashboard {
  padding: 0;
}

.dashboard-header {
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid var(--border);
}

.dashboard-title {
  font-size: 2.4rem;
  font-weight: 700;
  color: var(--text-primary);
  background: linear-gradient(135deg, var(--text-primary) 0%, var(--accent-l) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 0.4rem;
}

.dashboard-subtitle {
  font-size: 1.05rem;
  color: var(--text-secondary);
  margin: 0;
  font-weight: 400;
}

.dashboard-header-actions {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}

.db-advisory-banner {
  display: grid;
  grid-template-columns: minmax(280px, 1.4fr) minmax(320px, 1fr);
  gap: 1rem;
  padding: 1.1rem 1.2rem;
  margin-bottom: 1.2rem;
  border: 1px solid rgba(245, 158, 11, 0.35);
  border-radius: 14px;
  background:
    linear-gradient(135deg, rgba(245, 158, 11, 0.16), transparent 70%),
    var(--bg-toolbar);
}

.db-advisory-eyebrow {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--amber-600);
  margin-bottom: 0.35rem;
}

.db-advisory-copy h2 {
  margin: 0 0 0.45rem;
  font-size: 1.15rem;
  color: var(--text-primary);
}

.db-advisory-copy p {
  margin: 0;
  color: var(--text-secondary);
  line-height: 1.5;
}

.db-advisory-list {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}

.db-advisory-item,
.db-advisory-more {
  text-align: left;
  width: 100%;
  border-radius: 10px;
  border: 1px solid var(--border);
  background: var(--bg-toolbar);
  color: inherit;
  padding: 0.75rem 0.85rem;
  cursor: pointer;
  transition: border-color 0.2s ease, transform 0.2s ease, background 0.2s ease;
}

.db-advisory-item:hover,
.db-advisory-more:hover {
  border-color: rgba(251, 191, 36, 0.45);
  background: rgba(var(--accent-rgb), 0.10);
  transform: translateY(-1px);
}

.db-advisory-item-name {
  display: block;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 0.2rem;
}

.db-advisory-item-msg {
  display: block;
  font-size: 0.88rem;
  color: var(--text-secondary);
  line-height: 1.4;
}

.db-advisory-more {
  color: var(--amber-600);
  font-weight: 700;
}

/* Quick Access Grid */
.dashboard-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1rem;
  margin-bottom: 2.5rem;
}

.dashboard-card {
  display: flex;
  align-items: center;
  padding: 1.1rem 1.3rem;
  background: var(--bg-toolbar);
  border-radius: 12px;
  border: 1px solid var(--border);
  cursor: pointer;
  transition: border-color 0.2s ease, transform 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
  box-shadow: none;
}

.dashboard-card:hover {
  border-color: rgba(var(--accent-rgb),.5);
  transform: translateY(-2px);
  background: rgba(var(--accent-rgb),.08);
  box-shadow: 0 8px 24px rgba(0,0,0,.3);
}

.dashboard-card.not-implemented {
  opacity: 0.5;
  background: var(--bg-toolbar);
  border-color: var(--border);
}

.dashboard-card-icon {
  font-size: 1.5rem;
  margin-right: 1rem;
  min-width: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-muted);
  font-weight: 600;
}

.dashboard-card-content {
  flex: 1 1;
}

.dashboard-card-title {
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 0.3rem 0;
}

.dashboard-card-badge {
  display: inline-block;
  font-size: 0.75rem;
  color: var(--amber-600);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.dashboard-card-arrow {
  font-size: 1rem;
  color: var(--text-muted);
  transition: color 0.2s ease, transform 0.2s ease;
  margin-left: 0.5rem;
}

.dashboard-card:hover .dashboard-card-arrow {
  color: var(--accent);
  transform: translateX(2px);
}

/* Info Cards */
.dashboard-info {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 1rem;
  margin-top: 2.5rem;
}

.dashboard-info-card {
  padding: 1.2rem 1.4rem;
  background: var(--bg-toolbar);
  border-radius: 12px;
  border: 1px solid var(--border);
  box-shadow: none;
  transition: border-color 0.2s ease, transform 0.2s ease;
}

.dashboard-info-card:hover {
  border-color: #3b82f6;
  transform: translateY(-2px);
}

.dashboard-info-card h3 {
  font-size: 1.05rem;
  font-weight: 600;
  margin-bottom: 0.6rem;
  color: var(--text-primary);
}

.dashboard-info-card p {
  font-size: 0.93rem;
  margin: 0;
  color: var(--text-secondary);
  line-height: 1.5;
}

/* Responsive */
@media (max-width: 992px) {
  .dashboard-title {
    font-size: 2rem;
  }

  .dashboard-grid {
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 1rem;
  }
}

@media (max-width: 768px) {
  .db-advisory-banner {
    grid-template-columns: 1fr;
  }

  .dashboard-header {
    margin-bottom: 1.5rem;
  }

  .dashboard-title {
    font-size: 1.7rem;
  }

  .dashboard-subtitle {
    font-size: 1rem;
  }

  .dashboard-grid {
    grid-template-columns: 1fr;
  }

  .dashboard-card {
    padding: 1.1rem 1.3rem;
  }

  .dashboard-card-icon {
    font-size: 1.35rem;
    min-width: 34px;
  }

  .dashboard-info {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 576px) {
  .dashboard-card-icon {
    font-size: 1.2rem;
    margin-right: 0.85rem;
    min-width: 30px;
  }

  .dashboard-card-title {
    font-size: 0.98rem;
  }

  .dashboard-card-arrow {
    display: none;
  }
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(18px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.dashboard-card {
  animation: fadeIn 0.5s ease forwards;
}

.dashboard-card:nth-child(1) { animation-delay: 0.05s; }
.dashboard-card:nth-child(2) { animation-delay: 0.1s; }
.dashboard-card:nth-child(3) { animation-delay: 0.15s; }
.dashboard-card:nth-child(4) { animation-delay: 0.2s; }
.dashboard-card:nth-child(5) { animation-delay: 0.25s; }
.dashboard-card:nth-child(6) { animation-delay: 0.3s; }

/* ── Dashboard header refresh button ────────────────────────────────────── */
.dashboard-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
}

.db-refresh-btn {
  background: var(--bg-input);
  border: 1px solid var(--slate-300);
  color: var(--text-secondary);
  border-radius: 8px;
  padding: 0.45rem 1rem;
  font-size: 0.85rem;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
  white-space: nowrap;
  align-self: center;
}
.db-refresh-btn:hover:not(:disabled) {
  background: rgba(var(--accent-rgb),.2);
  color: #a5b4fc;
  border-color: rgba(var(--accent-rgb),.4);
}
.db-refresh-btn:disabled { opacity: 0.5; cursor: not-allowed; }

/* ── No-company placeholder ─────────────────────────────────────────────── */
.db-no-company {
  text-align: center;
  padding: 3rem 2rem;
  color: var(--text-muted);
  background: var(--bg-toolbar);
  border: 1px dashed var(--slate-300);
  border-radius: 14px;
  margin-bottom: 2rem;
}
.db-no-company-icon { font-size: 2.8rem; margin-bottom: 0.8rem; }
.db-no-company h3 { color: var(--text-secondary); font-size: 1.1rem; margin-bottom: 0.4rem; }
.db-no-company p  { font-size: 0.93rem; max-width: 380px; margin: 0 auto; }

/* ── KPI section ─────────────────────────────────────────────────────────── */
.db-kpi-section {
  margin-bottom: 2rem;
}

.db-metrics-collapsible {
  overflow: hidden;
  margin-top: 1rem;
}

.db-summary-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(255px, 1fr));
  gap: 0.85rem;
}

.db-summary-grid--snapshot {
  margin-top: 0.35rem;
}

.db-summary-card {
  border: 1px solid var(--border);
  background: var(--bg-toolbar);
  border-radius: 14px;
  padding: 0.85rem 0.9rem;
  text-align: left;
  cursor: pointer;
  transition: transform 0.18s ease, border-color 0.18s ease, background 0.18s ease;
}

.db-summary-card-shell {
  border: 1px solid var(--border);
  border-radius: 14px;
  background: var(--bg-toolbar);
  overflow: hidden;
}

.db-summary-card-shell .db-summary-card {
  border: none;
  border-radius: 0;
  /* La tarjeta interior debe llenar el contenedor: si no, en modo claro asoma
     la capa del contenedor y se ve una franja gris a su derecha. */
  display: block;
  width: 100%;
}

.db-summary-card-shell.is-expanded {
  border-color: rgba(var(--accent-rgb), 0.4);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.2);
}

.db-summary-card-shell--warning.is-expanded {
  border-color: rgba(245, 158, 11, 0.45);
}

.db-summary-card-shell--critical.is-expanded {
  border-color: rgba(239, 68, 68, 0.45);
}

.db-summary-card-shell--info.is-expanded {
  border-color: rgba(56, 189, 248, 0.45);
}

.db-summary-card-detail {
  padding: 0 0.75rem 0.75rem;
}

.db-summary-card-detail .db-advisory-banner,
.db-summary-card-detail .db-panel,
.db-summary-card-detail .db-occ-section {
  margin: 0;
  border-radius: 10px;
}

.db-summary-card-detail .db-panel,
.db-summary-card-detail .db-advisory-banner {
  padding: 0.75rem;
}

.db-summary-card-detail .db-panel-header {
  margin-bottom: 0.65rem;
}

.db-summary-card-detail .db-panel-header h3 {
  font-size: 0.92rem;
}

.db-summary-card-detail .db-feed-item {
  padding: 0.62rem 0.7rem;
  border-radius: 9px;
  gap: 0.16rem;
}

.db-summary-card-detail .db-feed-item-title {
  font-size: 0.86rem;
}

.db-summary-card-detail .db-feed-item-copy {
  font-size: 0.8rem;
  line-height: 1.35;
}

.db-summary-card-detail .db-feed-item-meta {
  font-size: 0.68rem;
}

.db-summary-card-detail .db-advisory-copy h2 {
  font-size: 0.95rem;
  margin-bottom: 0.28rem;
}

.db-summary-card-detail .db-advisory-copy p,
.db-summary-card-detail .db-advisory-item-msg {
  font-size: 0.8rem;
  line-height: 1.35;
}

.db-summary-card-detail .db-advisory-item,
.db-summary-card-detail .db-advisory-more {
  padding: 0.58rem 0.62rem;
  border-radius: 8px;
}

.db-summary-card-detail .db-advisory-list,
.db-summary-card-detail .db-feed-list {
  gap: 0.45rem;
}

.db-summary-card.is-expanded {
  border-color: rgba(var(--accent-rgb), 0.45);
  background: rgba(var(--accent-rgb), 0.12);
}

.db-summary-card:hover {
  transform: translateY(-2px);
  background: rgba(var(--accent-rgb), 0.08);
  border-color: rgba(var(--accent-rgb), 0.28);
}

.db-summary-card-topline {
  font-size: 0.69rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--text-muted);
  margin-bottom: 0.45rem;
}

.db-summary-card-main {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.8rem;
}

.db-summary-card-title {
  font-size: 0.93rem;
  font-weight: 700;
  color: var(--text-primary);
}

.db-summary-card-count {
  min-width: 36px;
  min-height: 36px;
  padding: 0 0.6rem;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.84rem;
  font-weight: 800;
}

.db-summary-card-count--critical {
  background: rgba(239, 68, 68, 0.16);
  color: var(--red-600);
}

.db-summary-card-count--warning {
  background: rgba(245, 158, 11, 0.16);
  color: var(--amber-600);
}

/* El tono informativo no tiene token propio en el sistema de diseño: se
   resuelve aquí para que sea legible en claro y en oscuro. */
.db-summary-card-count--info,
.db-panel-pill--info {
  --db-info-fg: #0284c7;
}

[data-base="dark"] :is(.db-summary-card-count--info, .db-panel-pill--info) {
  --db-info-fg: #7dd3fc;
}

.db-summary-card-count--info {
  background: rgba(56, 189, 248, 0.16);
  color: var(--db-info-fg);
}

.db-summary-card-secondary {
  margin-top: 0.45rem;
  color: var(--text-secondary);
  font-size: 0.76rem;
  line-height: 1.4;
}

.db-summary-card-action {
  margin-top: 0.42rem;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--text-muted);
}

.db-summary-card--snapshot {
  cursor: default;
}

.db-summary-card--snapshot:hover {
  transform: none;
  background: var(--bg-toolbar);
  border-color: var(--border);
}

.db-summary-card-count--snapshot {
  background: rgba(var(--accent-rgb), 0.12);
  color: var(--text-primary);
}

.db-no-issues-card {
  margin-top: 0.85rem;
  border: 1px dashed var(--border);
  border-radius: 12px;
  background: var(--bg-toolbar);
  color: var(--text-muted);
  text-align: center;
  padding: 1rem;
  font-size: 0.9rem;
}

/* Renovaciones próximas (DNS): aviso a 30 días, naranja; vencidas, rojo. */
.db-renewals {
  margin-top: 1rem;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: var(--bg-card);
  padding: 0.9rem 1rem;
}

.db-renewals-head {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-bottom: 0.5rem;
}

.db-renewals-head h3 {
  margin: 0;
  font-size: 0.95rem;
}

.db-renewals ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 6px;
}

.db-renewal {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  padding: 0.4rem 0.6rem;
  border-radius: 8px;
  border-left: 3px solid var(--amber-600, #d97706);
  background: rgba(245, 158, 11, 0.08);
  font-size: 0.82rem;
  color: var(--text-primary);
}

.db-renewal.is-expired {
  border-left-color: var(--red-600, #dc2626);
  background: rgba(239, 68, 68, 0.1);
}

.db-renewal-days {
  margin-left: auto;
  font-weight: 600;
}

.db-error {
  color: var(--red-600);
  background: rgba(239,68,68,.1);
  border: 1px solid rgba(239,68,68,.25);
  border-radius: 8px;
  padding: 0.7rem 1rem;
  font-size: 0.88rem;
  margin-bottom: 1rem;
}
.db-loading {
  color: var(--text-muted);
  padding: 1rem 0;
  font-size: 0.9rem;
}

/* ── Occupancy bar ───────────────────────────────────────────────────────── */
.db-occ-section {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: var(--bg-toolbar);
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 0.6rem 1rem;
}
.db-occ-section--card {
  padding: 0.5rem 0.6rem;
}
.db-occ-title { font-size: 0.8rem; color: var(--text-muted); text-transform: uppercase; letter-spacing: 0.06em; white-space: nowrap; min-width: 120px; }
.db-occ-wrap  { display: flex; align-items: center; gap: 0.6rem; flex: 1 1; }
.db-occ-track { flex: 1 1; height: 8px; background: var(--bg-toolbar); border-radius: 100px; overflow: hidden; }
.db-occ-fill  { height: 100%; border-radius: 100px; transition: width 0.6s ease; }
.db-occ-pct   { font-size: 0.85rem; font-weight: 600; min-width: 36px; text-align: right; }

.db-nav-wrapper {
  display: none;
}

.db-panel {
  background: var(--bg-toolbar);
  border: 1px solid var(--border);
  border-radius: 14px;
  padding: 1rem;
}

.db-panel-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.85rem;
}

.db-panel-header h3 {
  margin: 0;
  color: var(--text-primary);
  font-size: 1.05rem;
}

.db-panel-eyebrow {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--text-muted);
  margin-bottom: 0.25rem;
}

.db-panel-pill {
  min-width: 30px;
  height: 30px;
  padding: 0 0.55rem;
  border-radius: 999px;
  font-size: 0.8rem;
  font-weight: 800;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.db-panel-pill--critical {
  background: rgba(239, 68, 68, 0.14);
  color: var(--red-600);
}

.db-panel-pill--warning {
  background: rgba(245, 158, 11, 0.14);
  color: var(--amber-600);
}

.db-panel-pill--info {
  background: rgba(56, 189, 248, 0.14);
  color: var(--db-info-fg, #0284c7);
}

.db-feed-summary {
  display: flex;
  gap: 0.4rem;
}

.db-feed-list {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}

.db-feed-item {
  width: 100%;
  border: 1px solid var(--border);
  background: var(--bg-toolbar);
  border-radius: 12px;
  padding: 0.8rem 0.9rem;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  cursor: pointer;
  transition: border-color 0.2s ease, transform 0.2s ease, background 0.2s ease;
}

.db-feed-item:hover {
  transform: translateY(-1px);
  background: rgba(var(--accent-rgb), 0.10);
}

.db-feed-item--critical {
  border-color: rgba(239, 68, 68, 0.24);
}

.db-feed-item--warning {
  border-color: rgba(245, 158, 11, 0.24);
}

.db-feed-item--info {
  border-color: rgba(56, 189, 248, 0.22);
}

.db-feed-item-title {
  color: var(--text-primary);
  font-weight: 700;
}

.db-feed-item-copy {
  color: var(--text-secondary);
  font-size: 0.88rem;
  line-height: 1.45;
}

.db-feed-item-meta {
  color: var(--text-muted);
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.db-panel-empty {
  color: var(--text-muted);
  font-size: 0.88rem;
  padding: 0.4rem 0;
}

/* ── Navigation wrapper ──────────────────────────────────────────────────── */
.db-nav-wrapper {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

/* ── Nav section ─────────────────────────────────────────────────────────── */
.db-nav-section {}
.db-nav-section-title {
  font-size: 0.8rem;
  font-weight: 700;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin: 0 0 0.6rem 0;
  padding-bottom: 0.4rem;
  border-bottom: 1px solid var(--border);
}

.db-nav-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
  gap: 0.5rem;
}

.db-nav-card {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  padding: 0.55rem 0.85rem;
  background: var(--bg-toolbar);
  border: 1px solid var(--border);
  border-radius: 9px;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, transform 0.15s;
  text-align: left;
  color: var(--text-primary);
  font-size: 0.875rem;
}
.db-nav-card:hover {
  background: rgba(var(--accent-rgb),.12);
  border-color: rgba(var(--accent-rgb),.35);
  transform: translateX(2px);
}
.db-nav-icon  { font-size: 1rem; flex-shrink: 0; }
.db-nav-label { flex: 1 1; font-size: 0.85rem; color: var(--slate-700); }
.db-nav-arrow { font-size: 1rem; color: var(--text-muted); transition: color 0.15s; }
.db-nav-card:hover .db-nav-arrow { color: var(--accent); }

/* ── Responsive ──────────────────────────────────────────────────────────── */
@media (max-width: 768px) {
  .db-nav-grid { grid-template-columns: repeat(auto-fill, minmax(150px, 1fr)); }
  .db-occ-section { flex-direction: column; align-items: flex-start; }
  .db-occ-wrap { width: 100%; }
  .db-summary-grid { grid-template-columns: 1fr; }
}
@media (max-width: 480px) {
  .db-nav-grid { grid-template-columns: 1fr 1fr; }
}

/* Print */
@media print {
  .dashboard-info {
    display: none;
  }

  .dashboard-card {
    page-break-inside: avoid;
    break-inside: avoid;
    box-shadow: none;
    border: 1px solid var(--border);
  }

  .dashboard-card:hover {
    transform: none;
  }
}

/* ═══════════════════════════════════════════════════════════════════════════
   Contenido de fondo del panel: inventario, ocupación por rack y direccionamiento

   Las tarjetas de arriba solo existen cuando hay incidencias. Esto es lo que
   hace que el panel siga contando algo en un día tranquilo, así que va siempre
   visible y sin depender de que haya avisos.
   ═══════════════════════════════════════════════════════════════════════════ */

.db-content-grid {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(280px, 1fr);
  gap: 1rem;
}

@media (max-width: 1100px) {
  .db-content-grid {
    grid-template-columns: 1fr;
  }
}

.db-block {
  margin-top: 1rem;
  padding: 1.1rem 1.2rem;
  border: 1px solid var(--border);
  border-radius: var(--radius-xl);
  background: var(--bg-card);
  box-shadow: var(--shadow-sm);
}

.db-content-grid .db-block {
  margin-top: 0;
}

/* El bloque de IPAM tiene menos contenido que el inventario: si se estira a su
   altura queda media tarjeta vacía. */
.db-block--ipam {
  align-self: start;
}

.db-block-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-bottom: 0.9rem;
}

.db-block-title {
  margin: 0;
  font-size: 1rem;
  font-weight: var(--fw-semibold);
  letter-spacing: -0.01em;
  color: var(--text-primary);
}

.db-block-hint {
  font-size: 0.78rem;
  color: var(--text-muted);
}

/* ── Inventario ─────────────────────────────────────────────────────────── */

.db-inv-groups {
  display: grid;
  gap: 0.9rem;
}

.db-inv-group-label {
  display: block;
  margin-bottom: 0.4rem;
  font-size: 0.68rem;
  font-weight: var(--fw-bold);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--text-muted);
}

.db-inv-tiles {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(104px, 1fr));
  gap: 0.5rem;
}

.db-inv-tile {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.15rem;
  padding: 0.55rem 0.7rem;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  background: var(--bg-toolbar);
  font-family: inherit;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease, transform 0.12s ease;
}

.db-inv-tile:hover:not(:disabled) {
  border-color: rgba(var(--accent-rgb), 0.45);
  background: rgba(var(--accent-rgb), 0.07);
  transform: translateY(-1px);
}

.db-inv-tile:disabled {
  cursor: default;
  opacity: 0.7;
}

.db-inv-value {
  font-size: 1.35rem;
  font-weight: var(--fw-bold);
  line-height: 1.05;
  color: var(--text-primary);
}

.db-inv-label {
  font-size: 0.76rem;
  color: var(--text-secondary);
}

/* ── Ocupación por rack ─────────────────────────────────────────────────── */

.db-racks {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 0.6rem;
}

.db-rack {
  display: grid;
  /* La barra y el porcentaje son anchos fijos y cortos: el nombre del rack
     necesita el resto, o "Rack Demo A" parte en dos líneas. */
  grid-template-columns: minmax(0, 1fr) 84px 76px;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 0.6rem;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  background: var(--bg-toolbar);
  font-family: inherit;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.15s ease;
}

.db-rack:hover {
  border-color: rgba(var(--accent-rgb), 0.45);
}

.db-rack-name {
  display: flex;
  flex-direction: column;
  min-width: 0;
  font-size: 0.85rem;
  font-weight: var(--fw-semibold);
  color: var(--text-primary);
}

.db-rack-name em {
  font-style: normal;
  font-size: 0.72rem;
  font-weight: 400;
  color: var(--text-muted);
}

.db-rack-bar {
  display: block;
  height: 8px;
  border-radius: 999px;
  background: var(--bg-input);
  overflow: hidden;
}

.db-rack-bar i {
  display: block;
  height: 100%;
  border-radius: 999px;
  background: rgba(var(--accent-rgb), 0.75);
}

.db-rack-bar.is-warning i {
  background: var(--amber-600);
}

.db-rack-bar.is-critical i {
  background: var(--red-600);
}

.db-rack-pct {
  font-size: 0.8rem;
  font-weight: var(--fw-semibold);
  text-align: right;
  color: var(--text-primary);
}

.db-rack-pct em {
  display: block;
  font-style: normal;
  font-size: 0.7rem;
  font-weight: 400;
  color: var(--text-muted);
}

/* ── Direccionamiento IP ────────────────────────────────────────────────── */

.db-ipam-figure {
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
}

.db-ipam-value {
  font-size: 2rem;
  font-weight: var(--fw-bold);
  line-height: 1;
  color: var(--accent);
}

.db-ipam-value.is-critical {
  color: var(--red-600);
}

.db-ipam-caption {
  font-size: 0.8rem;
  color: var(--text-muted);
}

.db-ipam-bar {
  display: block;
  height: 8px;
  margin: 0.6rem 0 0.9rem;
  border-radius: 999px;
  background: var(--bg-input);
  overflow: hidden;
}

.db-ipam-bar i {
  display: block;
  height: 100%;
  border-radius: 999px;
  background: rgba(var(--accent-rgb), 0.75);
}

.db-ipam-bar i.is-critical {
  background: var(--red-600);
}

.db-ipam-facts {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.5rem;
}

.db-ipam-facts button {
  display: flex;
  align-items: baseline;
  gap: 0.35rem;
  padding: 0.45rem 0.6rem;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  background: var(--bg-toolbar);
  color: var(--text-secondary);
  font-family: inherit;
  font-size: 0.78rem;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease;
}

.db-ipam-facts button:hover {
  border-color: rgba(var(--accent-rgb), 0.45);
  color: var(--text-primary);
}

.db-ipam-facts b {
  font-size: 1rem;
  color: var(--text-primary);
}

.db-ipam-alert {
  margin: 0.8rem 0 0;
  padding: 0.55rem 0.7rem;
  border: 1px solid rgba(220, 38, 38, 0.3);
  border-radius: var(--radius-lg);
  background: rgba(220, 38, 38, 0.1);
  color: var(--text-secondary);
  font-size: 0.8rem;
  line-height: 1.45;
}

/* ── Hero del inicio + pestañas (2026-10-30) ───────────────────────────────
   El dashboard era una cabecera de texto y tres cajas. Ahora la cabecera es
   una banda con degradado suave, un eyebrow y chips con el inventario, y
   debajo dos pestañas: «Resumen» (lo que hay) y «Seguridad» (cómo está). */

.dashboard-header--hero {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
  flex-wrap: wrap;
  padding: 1.35rem 1.5rem;
  margin-bottom: 1rem;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg, 16px);
  border-bottom: 1px solid var(--border);
  background:
    radial-gradient(120% 160% at 0% 0%, rgba(var(--accent-rgb, 59, 130, 246), 0.16), transparent 62%),
    radial-gradient(90% 120% at 100% 0%, rgba(139, 92, 246, 0.12), transparent 60%),
    var(--bg-surface);
}

.dashboard-eyebrow {
  margin: 0 0 0.2rem;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--accent-l);
}

.dashboard-header--hero .dashboard-title {
  font-size: 2rem;
  margin: 0 0 0.25rem;
}

.dashboard-hero-chips {
  display: flex;
  gap: 0.45rem;
  flex-wrap: wrap;
  margin-top: 0.7rem;
}

.db-tabs {
  display: flex;
  gap: 0.35rem;
  margin: 0 0 1.25rem;
  padding: 0.25rem;
  width: fit-content;
  border: 1px solid var(--border);
  border-radius: 999px;
  background: var(--bg-surface);
}

.db-tab {
  border: 0;
  background: transparent;
  color: var(--text-secondary);
  font-size: 0.86rem;
  font-weight: 600;
  padding: 0.42rem 1.1rem;
  border-radius: 999px;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.db-tab:hover {
  color: var(--text-primary);
}

.db-tab.is-active {
  background: var(--accent);
  color: var(--accent-contrast, #fff);
}

@media (max-width: 720px) {
  .dashboard-header--hero { padding: 1rem; }
  .dashboard-header--hero .dashboard-title { font-size: 1.6rem; }
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,iFAAiF;EACjF,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8DAA8D;EAC9D,SAAS;EACT,sBAAsB;EACtB,qBAAqB;EACrB,0CAA0C;EAC1C,mBAAmB;EACnB;;qBAEmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;;EAEE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,+BAA+B;EAC/B,6BAA6B;EAC7B,cAAc;EACd,wBAAwB;EACxB,eAAe;EACf,6EAA6E;AAC/E;;AAEA;;EAEE,sCAAsC;EACtC,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,mGAAmG;EACnG,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;EAC3B,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,uDAAuD;AACzD;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,eAAe;EACjB;;EAEA;IACE,4DAA4D;IAC5D,SAAS;EACX;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,oCAAoC;AACtC;;AAEA,+BAA+B,sBAAsB,EAAE;AACvD,+BAA+B,qBAAqB,EAAE;AACtD,+BAA+B,sBAAsB,EAAE;AACvD,+BAA+B,qBAAqB,EAAE;AACtD,+BAA+B,sBAAsB,EAAE;AACvD,+BAA+B,qBAAqB,EAAE;;AAEtD,8EAA8E;AAC9E;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,4BAA4B;EAC5B,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,uCAAuC;EACvC,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,sCAAsC;EACtC,cAAc;EACd,wCAAwC;AAC1C;AACA,2BAA2B,YAAY,EAAE,mBAAmB,EAAE;;AAE9D,8EAA8E;AAC9E;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,6BAA6B;EAC7B,mCAAmC;EACnC,mBAAmB;EACnB,mBAAmB;AACrB;AACA,sBAAsB,iBAAiB,EAAE,qBAAqB,EAAE;AAChE,oBAAoB,4BAA4B,EAAE,iBAAiB,EAAE,qBAAqB,EAAE;AAC5F,oBAAoB,kBAAkB,EAAE,gBAAgB,EAAE,cAAc,EAAE;;AAE1E,+EAA+E;AAC/E;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,gFAAgF;AAClF;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB;mEACiE;EACjE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;;EAGE,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;EAEE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;EAEE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,2CAA2C;EAC3C,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;6DAC6D;AAC7D;;EAEE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;EACnB,6BAA6B;EAC7B,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;AACnB;;AAEA,2EAA2E;AAC3E;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gDAAgD;EAChD,oCAAoC;EACpC,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,qCAAqC;EACrC,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,eAAe;EACf,iBAAiB;AACnB;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;EAC7B,+BAA+B;EAC/B,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA,gBAAgB,iBAAiB,EAAE,wBAAwB,EAAE,yBAAyB,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AACvJ,gBAAgB,aAAa,EAAE,mBAAmB,EAAE,WAAW,EAAE,SAAO,EAAE;AAC1E,gBAAgB,SAAO,EAAE,WAAW,EAAE,6BAA6B,EAAE,oBAAoB,EAAE,gBAAgB,EAAE;AAC7G,gBAAgB,YAAY,EAAE,oBAAoB,EAAE,2BAA2B,EAAE;AACjF,gBAAgB,kBAAkB,EAAE,gBAAgB,EAAE,eAAe,EAAE,iBAAiB,EAAE;;AAE1F;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,6BAA6B;EAC7B,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,6EAA6E;AAC/E;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA,+EAA+E;AAC/E,iBAAiB;AACjB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,6BAA6B;EAC7B,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,iEAAiE;EACjE,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,uCAAuC;EACvC,yCAAyC;EACzC,0BAA0B;AAC5B;AACA,gBAAgB,eAAe,EAAE,cAAc,EAAE;AACjD,gBAAgB,SAAO,EAAE,kBAAkB,EAAE,uBAAuB,EAAE;AACtE,gBAAgB,eAAe,EAAE,wBAAwB,EAAE,uBAAuB,EAAE;AACpF,mCAAmC,oBAAoB,EAAE;;AAEzD,+EAA+E;AAC/E;EACE,eAAe,4DAA4D,EAAE;EAC7E,kBAAkB,sBAAsB,EAAE,uBAAuB,EAAE;EACnE,eAAe,WAAW,EAAE;EAC5B,mBAAmB,0BAA0B,EAAE;AACjD;AACA;EACE,eAAe,8BAA8B,EAAE;AACjD;;AAEA,UAAU;AACV;EACE;IACE,aAAa;EACf;;EAEA;IACE,wBAAmB;IAAnB,mBAAmB;IACnB,gBAAgB;IAChB,+BAA+B;EACjC;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;;;;;gFAMgF;;AAEhF;EACE,aAAa;EACb,wDAAwD;EACxD,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;sCACsC;AACtC;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,+BAA+B;EAC/B,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,8EAA8E;;AAE9E;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,+BAA+B;EAC/B,+BAA+B;EAC/B,6BAA6B;EAC7B,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,sFAAsF;AACxF;;AAEA;EACE,2CAA2C;EAC3C,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,8EAA8E;;AAE9E;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,aAAa;EACb;8DAC4D;EAC5D,+CAA+C;EAC/C,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,+BAA+B;EAC/B,+BAA+B;EAC/B,6BAA6B;EAC7B,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,oBAAoB;EACpB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA,8EAA8E;;AAE9E;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,uBAAuB;EACvB,oBAAoB;EACpB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,uBAAuB;EACvB,+BAA+B;EAC/B,+BAA+B;EAC/B,6BAA6B;EAC7B,4BAA4B;EAC5B,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,2CAA2C;EAC3C,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,wCAAwC;EACxC,+BAA+B;EAC/B,kCAAkC;EAClC,4BAA4B;EAC5B,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;;2EAG2E;;AAE3E;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;EAC/B,qCAAqC;EACrC,sCAAsC;EACtC;;;qBAGmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,0BAA0B,aAAa,EAAE;EACzC,2CAA2C,iBAAiB,EAAE;AAChE","sourcesContent":["/**\r\n * Dashboard Styles - Dark theme (matches IdP design system)\r\n */\r\n\r\n.dashboard {\r\n  padding: 0;\r\n}\r\n\r\n.dashboard-header {\r\n  margin-bottom: 2rem;\r\n  padding-bottom: 1.5rem;\r\n  border-bottom: 1px solid var(--border);\r\n}\r\n\r\n.dashboard-title {\r\n  font-size: 2.4rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  background: linear-gradient(135deg, var(--text-primary) 0%, var(--accent-l) 100%);\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  background-clip: text;\r\n  margin-bottom: 0.4rem;\r\n}\r\n\r\n.dashboard-subtitle {\r\n  font-size: 1.05rem;\r\n  color: var(--text-secondary);\r\n  margin: 0;\r\n  font-weight: 400;\r\n}\r\n\r\n.dashboard-header-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.6rem;\r\n}\r\n\r\n.db-advisory-banner {\r\n  display: grid;\r\n  grid-template-columns: minmax(280px, 1.4fr) minmax(320px, 1fr);\r\n  gap: 1rem;\r\n  padding: 1.1rem 1.2rem;\r\n  margin-bottom: 1.2rem;\r\n  border: 1px solid rgba(245, 158, 11, 0.35);\r\n  border-radius: 14px;\r\n  background:\r\n    linear-gradient(135deg, rgba(245, 158, 11, 0.16), transparent 70%),\r\n    var(--bg-toolbar);\r\n}\r\n\r\n.db-advisory-eyebrow {\r\n  font-size: 0.72rem;\r\n  font-weight: 700;\r\n  letter-spacing: 0.08em;\r\n  text-transform: uppercase;\r\n  color: var(--amber-600);\r\n  margin-bottom: 0.35rem;\r\n}\r\n\r\n.db-advisory-copy h2 {\r\n  margin: 0 0 0.45rem;\r\n  font-size: 1.15rem;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.db-advisory-copy p {\r\n  margin: 0;\r\n  color: var(--text-secondary);\r\n  line-height: 1.5;\r\n}\r\n\r\n.db-advisory-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.65rem;\r\n}\r\n\r\n.db-advisory-item,\r\n.db-advisory-more {\r\n  text-align: left;\r\n  width: 100%;\r\n  border-radius: 10px;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-toolbar);\r\n  color: inherit;\r\n  padding: 0.75rem 0.85rem;\r\n  cursor: pointer;\r\n  transition: border-color 0.2s ease, transform 0.2s ease, background 0.2s ease;\r\n}\r\n\r\n.db-advisory-item:hover,\r\n.db-advisory-more:hover {\r\n  border-color: rgba(251, 191, 36, 0.45);\r\n  background: rgba(var(--accent-rgb), 0.10);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.db-advisory-item-name {\r\n  display: block;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  margin-bottom: 0.2rem;\r\n}\r\n\r\n.db-advisory-item-msg {\r\n  display: block;\r\n  font-size: 0.88rem;\r\n  color: var(--text-secondary);\r\n  line-height: 1.4;\r\n}\r\n\r\n.db-advisory-more {\r\n  color: var(--amber-600);\r\n  font-weight: 700;\r\n}\r\n\r\n/* Quick Access Grid */\r\n.dashboard-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\r\n  gap: 1rem;\r\n  margin-bottom: 2.5rem;\r\n}\r\n\r\n.dashboard-card {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 1.1rem 1.3rem;\r\n  background: var(--bg-toolbar);\r\n  border-radius: 12px;\r\n  border: 1px solid var(--border);\r\n  cursor: pointer;\r\n  transition: border-color 0.2s ease, transform 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;\r\n  box-shadow: none;\r\n}\r\n\r\n.dashboard-card:hover {\r\n  border-color: rgba(var(--accent-rgb),.5);\r\n  transform: translateY(-2px);\r\n  background: rgba(var(--accent-rgb),.08);\r\n  box-shadow: 0 8px 24px rgba(0,0,0,.3);\r\n}\r\n\r\n.dashboard-card.not-implemented {\r\n  opacity: 0.5;\r\n  background: var(--bg-toolbar);\r\n  border-color: var(--border);\r\n}\r\n\r\n.dashboard-card-icon {\r\n  font-size: 1.5rem;\r\n  margin-right: 1rem;\r\n  min-width: 38px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: var(--text-muted);\r\n  font-weight: 600;\r\n}\r\n\r\n.dashboard-card-content {\r\n  flex: 1;\r\n}\r\n\r\n.dashboard-card-title {\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  margin: 0 0 0.3rem 0;\r\n}\r\n\r\n.dashboard-card-badge {\r\n  display: inline-block;\r\n  font-size: 0.75rem;\r\n  color: var(--amber-600);\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.4px;\r\n}\r\n\r\n.dashboard-card-arrow {\r\n  font-size: 1rem;\r\n  color: var(--text-muted);\r\n  transition: color 0.2s ease, transform 0.2s ease;\r\n  margin-left: 0.5rem;\r\n}\r\n\r\n.dashboard-card:hover .dashboard-card-arrow {\r\n  color: var(--accent);\r\n  transform: translateX(2px);\r\n}\r\n\r\n/* Info Cards */\r\n.dashboard-info {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\r\n  gap: 1rem;\r\n  margin-top: 2.5rem;\r\n}\r\n\r\n.dashboard-info-card {\r\n  padding: 1.2rem 1.4rem;\r\n  background: var(--bg-toolbar);\r\n  border-radius: 12px;\r\n  border: 1px solid var(--border);\r\n  box-shadow: none;\r\n  transition: border-color 0.2s ease, transform 0.2s ease;\r\n}\r\n\r\n.dashboard-info-card:hover {\r\n  border-color: #3b82f6;\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.dashboard-info-card h3 {\r\n  font-size: 1.05rem;\r\n  font-weight: 600;\r\n  margin-bottom: 0.6rem;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.dashboard-info-card p {\r\n  font-size: 0.93rem;\r\n  margin: 0;\r\n  color: var(--text-secondary);\r\n  line-height: 1.5;\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 992px) {\r\n  .dashboard-title {\r\n    font-size: 2rem;\r\n  }\r\n\r\n  .dashboard-grid {\r\n    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\r\n    gap: 1rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .db-advisory-banner {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .dashboard-header {\r\n    margin-bottom: 1.5rem;\r\n  }\r\n\r\n  .dashboard-title {\r\n    font-size: 1.7rem;\r\n  }\r\n\r\n  .dashboard-subtitle {\r\n    font-size: 1rem;\r\n  }\r\n\r\n  .dashboard-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .dashboard-card {\r\n    padding: 1.1rem 1.3rem;\r\n  }\r\n\r\n  .dashboard-card-icon {\r\n    font-size: 1.35rem;\r\n    min-width: 34px;\r\n  }\r\n\r\n  .dashboard-info {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n@media (max-width: 576px) {\r\n  .dashboard-card-icon {\r\n    font-size: 1.2rem;\r\n    margin-right: 0.85rem;\r\n    min-width: 30px;\r\n  }\r\n\r\n  .dashboard-card-title {\r\n    font-size: 0.98rem;\r\n  }\r\n\r\n  .dashboard-card-arrow {\r\n    display: none;\r\n  }\r\n}\r\n\r\n/* Animations */\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(18px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n.dashboard-card {\r\n  animation: fadeIn 0.5s ease forwards;\r\n}\r\n\r\n.dashboard-card:nth-child(1) { animation-delay: 0.05s; }\r\n.dashboard-card:nth-child(2) { animation-delay: 0.1s; }\r\n.dashboard-card:nth-child(3) { animation-delay: 0.15s; }\r\n.dashboard-card:nth-child(4) { animation-delay: 0.2s; }\r\n.dashboard-card:nth-child(5) { animation-delay: 0.25s; }\r\n.dashboard-card:nth-child(6) { animation-delay: 0.3s; }\r\n\r\n/* ── Dashboard header refresh button ────────────────────────────────────── */\r\n.dashboard-header {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  flex-wrap: wrap;\r\n  gap: 1rem;\r\n}\r\n\r\n.db-refresh-btn {\r\n  background: var(--bg-input);\r\n  border: 1px solid var(--slate-300);\r\n  color: var(--text-secondary);\r\n  border-radius: 8px;\r\n  padding: 0.45rem 1rem;\r\n  font-size: 0.85rem;\r\n  cursor: pointer;\r\n  transition: background 0.2s, color 0.2s;\r\n  white-space: nowrap;\r\n  align-self: center;\r\n}\r\n.db-refresh-btn:hover:not(:disabled) {\r\n  background: rgba(var(--accent-rgb),.2);\r\n  color: #a5b4fc;\r\n  border-color: rgba(var(--accent-rgb),.4);\r\n}\r\n.db-refresh-btn:disabled { opacity: 0.5; cursor: not-allowed; }\r\n\r\n/* ── No-company placeholder ─────────────────────────────────────────────── */\r\n.db-no-company {\r\n  text-align: center;\r\n  padding: 3rem 2rem;\r\n  color: var(--text-muted);\r\n  background: var(--bg-toolbar);\r\n  border: 1px dashed var(--slate-300);\r\n  border-radius: 14px;\r\n  margin-bottom: 2rem;\r\n}\r\n.db-no-company-icon { font-size: 2.8rem; margin-bottom: 0.8rem; }\r\n.db-no-company h3 { color: var(--text-secondary); font-size: 1.1rem; margin-bottom: 0.4rem; }\r\n.db-no-company p  { font-size: 0.93rem; max-width: 380px; margin: 0 auto; }\r\n\r\n/* ── KPI section ─────────────────────────────────────────────────────────── */\r\n.db-kpi-section {\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.db-metrics-collapsible {\r\n  overflow: hidden;\r\n  margin-top: 1rem;\r\n}\r\n\r\n.db-summary-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(255px, 1fr));\r\n  gap: 0.85rem;\r\n}\r\n\r\n.db-summary-grid--snapshot {\r\n  margin-top: 0.35rem;\r\n}\r\n\r\n.db-summary-card {\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-toolbar);\r\n  border-radius: 14px;\r\n  padding: 0.85rem 0.9rem;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  transition: transform 0.18s ease, border-color 0.18s ease, background 0.18s ease;\r\n}\r\n\r\n.db-summary-card-shell {\r\n  border: 1px solid var(--border);\r\n  border-radius: 14px;\r\n  background: var(--bg-toolbar);\r\n  overflow: hidden;\r\n}\r\n\r\n.db-summary-card-shell .db-summary-card {\r\n  border: none;\r\n  border-radius: 0;\r\n  /* La tarjeta interior debe llenar el contenedor: si no, en modo claro asoma\r\n     la capa del contenedor y se ve una franja gris a su derecha. */\r\n  display: block;\r\n  width: 100%;\r\n}\r\n\r\n.db-summary-card-shell.is-expanded {\r\n  border-color: rgba(var(--accent-rgb), 0.4);\r\n  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.db-summary-card-shell--warning.is-expanded {\r\n  border-color: rgba(245, 158, 11, 0.45);\r\n}\r\n\r\n.db-summary-card-shell--critical.is-expanded {\r\n  border-color: rgba(239, 68, 68, 0.45);\r\n}\r\n\r\n.db-summary-card-shell--info.is-expanded {\r\n  border-color: rgba(56, 189, 248, 0.45);\r\n}\r\n\r\n.db-summary-card-detail {\r\n  padding: 0 0.75rem 0.75rem;\r\n}\r\n\r\n.db-summary-card-detail .db-advisory-banner,\r\n.db-summary-card-detail .db-panel,\r\n.db-summary-card-detail .db-occ-section {\r\n  margin: 0;\r\n  border-radius: 10px;\r\n}\r\n\r\n.db-summary-card-detail .db-panel,\r\n.db-summary-card-detail .db-advisory-banner {\r\n  padding: 0.75rem;\r\n}\r\n\r\n.db-summary-card-detail .db-panel-header {\r\n  margin-bottom: 0.65rem;\r\n}\r\n\r\n.db-summary-card-detail .db-panel-header h3 {\r\n  font-size: 0.92rem;\r\n}\r\n\r\n.db-summary-card-detail .db-feed-item {\r\n  padding: 0.62rem 0.7rem;\r\n  border-radius: 9px;\r\n  gap: 0.16rem;\r\n}\r\n\r\n.db-summary-card-detail .db-feed-item-title {\r\n  font-size: 0.86rem;\r\n}\r\n\r\n.db-summary-card-detail .db-feed-item-copy {\r\n  font-size: 0.8rem;\r\n  line-height: 1.35;\r\n}\r\n\r\n.db-summary-card-detail .db-feed-item-meta {\r\n  font-size: 0.68rem;\r\n}\r\n\r\n.db-summary-card-detail .db-advisory-copy h2 {\r\n  font-size: 0.95rem;\r\n  margin-bottom: 0.28rem;\r\n}\r\n\r\n.db-summary-card-detail .db-advisory-copy p,\r\n.db-summary-card-detail .db-advisory-item-msg {\r\n  font-size: 0.8rem;\r\n  line-height: 1.35;\r\n}\r\n\r\n.db-summary-card-detail .db-advisory-item,\r\n.db-summary-card-detail .db-advisory-more {\r\n  padding: 0.58rem 0.62rem;\r\n  border-radius: 8px;\r\n}\r\n\r\n.db-summary-card-detail .db-advisory-list,\r\n.db-summary-card-detail .db-feed-list {\r\n  gap: 0.45rem;\r\n}\r\n\r\n.db-summary-card.is-expanded {\r\n  border-color: rgba(var(--accent-rgb), 0.45);\r\n  background: rgba(var(--accent-rgb), 0.12);\r\n}\r\n\r\n.db-summary-card:hover {\r\n  transform: translateY(-2px);\r\n  background: rgba(var(--accent-rgb), 0.08);\r\n  border-color: rgba(var(--accent-rgb), 0.28);\r\n}\r\n\r\n.db-summary-card-topline {\r\n  font-size: 0.69rem;\r\n  font-weight: 700;\r\n  letter-spacing: 0.08em;\r\n  text-transform: uppercase;\r\n  color: var(--text-muted);\r\n  margin-bottom: 0.45rem;\r\n}\r\n\r\n.db-summary-card-main {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 0.8rem;\r\n}\r\n\r\n.db-summary-card-title {\r\n  font-size: 0.93rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.db-summary-card-count {\r\n  min-width: 36px;\r\n  min-height: 36px;\r\n  padding: 0 0.6rem;\r\n  border-radius: 999px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 0.84rem;\r\n  font-weight: 800;\r\n}\r\n\r\n.db-summary-card-count--critical {\r\n  background: rgba(239, 68, 68, 0.16);\r\n  color: var(--red-600);\r\n}\r\n\r\n.db-summary-card-count--warning {\r\n  background: rgba(245, 158, 11, 0.16);\r\n  color: var(--amber-600);\r\n}\r\n\r\n/* El tono informativo no tiene token propio en el sistema de diseño: se\r\n   resuelve aquí para que sea legible en claro y en oscuro. */\r\n.db-summary-card-count--info,\r\n.db-panel-pill--info {\r\n  --db-info-fg: #0284c7;\r\n}\r\n\r\n[data-base=\"dark\"] :is(.db-summary-card-count--info, .db-panel-pill--info) {\r\n  --db-info-fg: #7dd3fc;\r\n}\r\n\r\n.db-summary-card-count--info {\r\n  background: rgba(56, 189, 248, 0.16);\r\n  color: var(--db-info-fg);\r\n}\r\n\r\n.db-summary-card-secondary {\r\n  margin-top: 0.45rem;\r\n  color: var(--text-secondary);\r\n  font-size: 0.76rem;\r\n  line-height: 1.4;\r\n}\r\n\r\n.db-summary-card-action {\r\n  margin-top: 0.42rem;\r\n  font-size: 0.68rem;\r\n  font-weight: 700;\r\n  letter-spacing: 0.04em;\r\n  text-transform: uppercase;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.db-summary-card--snapshot {\r\n  cursor: default;\r\n}\r\n\r\n.db-summary-card--snapshot:hover {\r\n  transform: none;\r\n  background: var(--bg-toolbar);\r\n  border-color: var(--border);\r\n}\r\n\r\n.db-summary-card-count--snapshot {\r\n  background: rgba(var(--accent-rgb), 0.12);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.db-no-issues-card {\r\n  margin-top: 0.85rem;\r\n  border: 1px dashed var(--border);\r\n  border-radius: 12px;\r\n  background: var(--bg-toolbar);\r\n  color: var(--text-muted);\r\n  text-align: center;\r\n  padding: 1rem;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n/* Renovaciones próximas (DNS): aviso a 30 días, naranja; vencidas, rojo. */\r\n.db-renewals {\r\n  margin-top: 1rem;\r\n  border: 1px solid var(--border);\r\n  border-radius: 12px;\r\n  background: var(--bg-card);\r\n  padding: 0.9rem 1rem;\r\n}\r\n\r\n.db-renewals-head {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  flex-wrap: wrap;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.db-renewals-head h3 {\r\n  margin: 0;\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.db-renewals ul {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  display: grid;\r\n  gap: 6px;\r\n}\r\n\r\n.db-renewal {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  flex-wrap: wrap;\r\n  padding: 0.4rem 0.6rem;\r\n  border-radius: 8px;\r\n  border-left: 3px solid var(--amber-600, #d97706);\r\n  background: rgba(245, 158, 11, 0.08);\r\n  font-size: 0.82rem;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.db-renewal.is-expired {\r\n  border-left-color: var(--red-600, #dc2626);\r\n  background: rgba(239, 68, 68, 0.1);\r\n}\r\n\r\n.db-renewal-days {\r\n  margin-left: auto;\r\n  font-weight: 600;\r\n}\r\n\r\n.db-error {\r\n  color: var(--red-600);\r\n  background: rgba(239,68,68,.1);\r\n  border: 1px solid rgba(239,68,68,.25);\r\n  border-radius: 8px;\r\n  padding: 0.7rem 1rem;\r\n  font-size: 0.88rem;\r\n  margin-bottom: 1rem;\r\n}\r\n.db-loading {\r\n  color: var(--text-muted);\r\n  padding: 1rem 0;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n/* ── Occupancy bar ───────────────────────────────────────────────────────── */\r\n.db-occ-section {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  background: var(--bg-toolbar);\r\n  border: 1px solid var(--border);\r\n  border-radius: 10px;\r\n  padding: 0.6rem 1rem;\r\n}\r\n.db-occ-section--card {\r\n  padding: 0.5rem 0.6rem;\r\n}\r\n.db-occ-title { font-size: 0.8rem; color: var(--text-muted); text-transform: uppercase; letter-spacing: 0.06em; white-space: nowrap; min-width: 120px; }\r\n.db-occ-wrap  { display: flex; align-items: center; gap: 0.6rem; flex: 1; }\r\n.db-occ-track { flex: 1; height: 8px; background: var(--bg-toolbar); border-radius: 100px; overflow: hidden; }\r\n.db-occ-fill  { height: 100%; border-radius: 100px; transition: width 0.6s ease; }\r\n.db-occ-pct   { font-size: 0.85rem; font-weight: 600; min-width: 36px; text-align: right; }\r\n\r\n.db-nav-wrapper {\r\n  display: none;\r\n}\r\n\r\n.db-panel {\r\n  background: var(--bg-toolbar);\r\n  border: 1px solid var(--border);\r\n  border-radius: 14px;\r\n  padding: 1rem;\r\n}\r\n\r\n.db-panel-header {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 0.75rem;\r\n  margin-bottom: 0.85rem;\r\n}\r\n\r\n.db-panel-header h3 {\r\n  margin: 0;\r\n  color: var(--text-primary);\r\n  font-size: 1.05rem;\r\n}\r\n\r\n.db-panel-eyebrow {\r\n  font-size: 0.72rem;\r\n  font-weight: 700;\r\n  letter-spacing: 0.08em;\r\n  text-transform: uppercase;\r\n  color: var(--text-muted);\r\n  margin-bottom: 0.25rem;\r\n}\r\n\r\n.db-panel-pill {\r\n  min-width: 30px;\r\n  height: 30px;\r\n  padding: 0 0.55rem;\r\n  border-radius: 999px;\r\n  font-size: 0.8rem;\r\n  font-weight: 800;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.db-panel-pill--critical {\r\n  background: rgba(239, 68, 68, 0.14);\r\n  color: var(--red-600);\r\n}\r\n\r\n.db-panel-pill--warning {\r\n  background: rgba(245, 158, 11, 0.14);\r\n  color: var(--amber-600);\r\n}\r\n\r\n.db-panel-pill--info {\r\n  background: rgba(56, 189, 248, 0.14);\r\n  color: var(--db-info-fg, #0284c7);\r\n}\r\n\r\n.db-feed-summary {\r\n  display: flex;\r\n  gap: 0.4rem;\r\n}\r\n\r\n.db-feed-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.65rem;\r\n}\r\n\r\n.db-feed-item {\r\n  width: 100%;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-toolbar);\r\n  border-radius: 12px;\r\n  padding: 0.8rem 0.9rem;\r\n  text-align: left;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.2rem;\r\n  cursor: pointer;\r\n  transition: border-color 0.2s ease, transform 0.2s ease, background 0.2s ease;\r\n}\r\n\r\n.db-feed-item:hover {\r\n  transform: translateY(-1px);\r\n  background: rgba(var(--accent-rgb), 0.10);\r\n}\r\n\r\n.db-feed-item--critical {\r\n  border-color: rgba(239, 68, 68, 0.24);\r\n}\r\n\r\n.db-feed-item--warning {\r\n  border-color: rgba(245, 158, 11, 0.24);\r\n}\r\n\r\n.db-feed-item--info {\r\n  border-color: rgba(56, 189, 248, 0.22);\r\n}\r\n\r\n.db-feed-item-title {\r\n  color: var(--text-primary);\r\n  font-weight: 700;\r\n}\r\n\r\n.db-feed-item-copy {\r\n  color: var(--text-secondary);\r\n  font-size: 0.88rem;\r\n  line-height: 1.45;\r\n}\r\n\r\n.db-feed-item-meta {\r\n  color: var(--text-muted);\r\n  font-size: 0.75rem;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n}\r\n\r\n.db-panel-empty {\r\n  color: var(--text-muted);\r\n  font-size: 0.88rem;\r\n  padding: 0.4rem 0;\r\n}\r\n\r\n/* ── Navigation wrapper ──────────────────────────────────────────────────── */\r\n.db-nav-wrapper {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1.5rem;\r\n}\r\n\r\n/* ── Nav section ─────────────────────────────────────────────────────────── */\r\n.db-nav-section {}\r\n.db-nav-section-title {\r\n  font-size: 0.8rem;\r\n  font-weight: 700;\r\n  color: var(--text-muted);\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.1em;\r\n  margin: 0 0 0.6rem 0;\r\n  padding-bottom: 0.4rem;\r\n  border-bottom: 1px solid var(--border);\r\n}\r\n\r\n.db-nav-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));\r\n  gap: 0.5rem;\r\n}\r\n\r\n.db-nav-card {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.55rem;\r\n  padding: 0.55rem 0.85rem;\r\n  background: var(--bg-toolbar);\r\n  border: 1px solid var(--border);\r\n  border-radius: 9px;\r\n  cursor: pointer;\r\n  transition: background 0.15s, border-color 0.15s, transform 0.15s;\r\n  text-align: left;\r\n  color: var(--text-primary);\r\n  font-size: 0.875rem;\r\n}\r\n.db-nav-card:hover {\r\n  background: rgba(var(--accent-rgb),.12);\r\n  border-color: rgba(var(--accent-rgb),.35);\r\n  transform: translateX(2px);\r\n}\r\n.db-nav-icon  { font-size: 1rem; flex-shrink: 0; }\r\n.db-nav-label { flex: 1; font-size: 0.85rem; color: var(--slate-700); }\r\n.db-nav-arrow { font-size: 1rem; color: var(--text-muted); transition: color 0.15s; }\r\n.db-nav-card:hover .db-nav-arrow { color: var(--accent); }\r\n\r\n/* ── Responsive ──────────────────────────────────────────────────────────── */\r\n@media (max-width: 768px) {\r\n  .db-nav-grid { grid-template-columns: repeat(auto-fill, minmax(150px, 1fr)); }\r\n  .db-occ-section { flex-direction: column; align-items: flex-start; }\r\n  .db-occ-wrap { width: 100%; }\r\n  .db-summary-grid { grid-template-columns: 1fr; }\r\n}\r\n@media (max-width: 480px) {\r\n  .db-nav-grid { grid-template-columns: 1fr 1fr; }\r\n}\r\n\r\n/* Print */\r\n@media print {\r\n  .dashboard-info {\r\n    display: none;\r\n  }\r\n\r\n  .dashboard-card {\r\n    break-inside: avoid;\r\n    box-shadow: none;\r\n    border: 1px solid var(--border);\r\n  }\r\n\r\n  .dashboard-card:hover {\r\n    transform: none;\r\n  }\r\n}\r\n\r\n/* ═══════════════════════════════════════════════════════════════════════════\r\n   Contenido de fondo del panel: inventario, ocupación por rack y direccionamiento\r\n\r\n   Las tarjetas de arriba solo existen cuando hay incidencias. Esto es lo que\r\n   hace que el panel siga contando algo en un día tranquilo, así que va siempre\r\n   visible y sin depender de que haya avisos.\r\n   ═══════════════════════════════════════════════════════════════════════════ */\r\n\r\n.db-content-grid {\r\n  display: grid;\r\n  grid-template-columns: minmax(0, 2fr) minmax(280px, 1fr);\r\n  gap: 1rem;\r\n}\r\n\r\n@media (max-width: 1100px) {\r\n  .db-content-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n.db-block {\r\n  margin-top: 1rem;\r\n  padding: 1.1rem 1.2rem;\r\n  border: 1px solid var(--border);\r\n  border-radius: var(--radius-xl);\r\n  background: var(--bg-card);\r\n  box-shadow: var(--shadow-sm);\r\n}\r\n\r\n.db-content-grid .db-block {\r\n  margin-top: 0;\r\n}\r\n\r\n/* El bloque de IPAM tiene menos contenido que el inventario: si se estira a su\r\n   altura queda media tarjeta vacía. */\r\n.db-block--ipam {\r\n  align-self: start;\r\n}\r\n\r\n.db-block-head {\r\n  display: flex;\r\n  align-items: baseline;\r\n  justify-content: space-between;\r\n  flex-wrap: wrap;\r\n  gap: 0.75rem;\r\n  margin-bottom: 0.9rem;\r\n}\r\n\r\n.db-block-title {\r\n  margin: 0;\r\n  font-size: 1rem;\r\n  font-weight: var(--fw-semibold);\r\n  letter-spacing: -0.01em;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.db-block-hint {\r\n  font-size: 0.78rem;\r\n  color: var(--text-muted);\r\n}\r\n\r\n/* ── Inventario ─────────────────────────────────────────────────────────── */\r\n\r\n.db-inv-groups {\r\n  display: grid;\r\n  gap: 0.9rem;\r\n}\r\n\r\n.db-inv-group-label {\r\n  display: block;\r\n  margin-bottom: 0.4rem;\r\n  font-size: 0.68rem;\r\n  font-weight: var(--fw-bold);\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.08em;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.db-inv-tiles {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(104px, 1fr));\r\n  gap: 0.5rem;\r\n}\r\n\r\n.db-inv-tile {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  gap: 0.15rem;\r\n  padding: 0.55rem 0.7rem;\r\n  border: 1px solid var(--border);\r\n  border-radius: var(--radius-lg);\r\n  background: var(--bg-toolbar);\r\n  font-family: inherit;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  transition: border-color 0.15s ease, background-color 0.15s ease, transform 0.12s ease;\r\n}\r\n\r\n.db-inv-tile:hover:not(:disabled) {\r\n  border-color: rgba(var(--accent-rgb), 0.45);\r\n  background: rgba(var(--accent-rgb), 0.07);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.db-inv-tile:disabled {\r\n  cursor: default;\r\n  opacity: 0.7;\r\n}\r\n\r\n.db-inv-value {\r\n  font-size: 1.35rem;\r\n  font-weight: var(--fw-bold);\r\n  line-height: 1.05;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.db-inv-label {\r\n  font-size: 0.76rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n/* ── Ocupación por rack ─────────────────────────────────────────────────── */\r\n\r\n.db-racks {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\r\n  gap: 0.6rem;\r\n}\r\n\r\n.db-rack {\r\n  display: grid;\r\n  /* La barra y el porcentaje son anchos fijos y cortos: el nombre del rack\r\n     necesita el resto, o \"Rack Demo A\" parte en dos líneas. */\r\n  grid-template-columns: minmax(0, 1fr) 84px 76px;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  padding: 0.5rem 0.6rem;\r\n  border: 1px solid var(--border);\r\n  border-radius: var(--radius-lg);\r\n  background: var(--bg-toolbar);\r\n  font-family: inherit;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  transition: border-color 0.15s ease;\r\n}\r\n\r\n.db-rack:hover {\r\n  border-color: rgba(var(--accent-rgb), 0.45);\r\n}\r\n\r\n.db-rack-name {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n  font-size: 0.85rem;\r\n  font-weight: var(--fw-semibold);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.db-rack-name em {\r\n  font-style: normal;\r\n  font-size: 0.72rem;\r\n  font-weight: 400;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.db-rack-bar {\r\n  display: block;\r\n  height: 8px;\r\n  border-radius: 999px;\r\n  background: var(--bg-input);\r\n  overflow: hidden;\r\n}\r\n\r\n.db-rack-bar i {\r\n  display: block;\r\n  height: 100%;\r\n  border-radius: 999px;\r\n  background: rgba(var(--accent-rgb), 0.75);\r\n}\r\n\r\n.db-rack-bar.is-warning i {\r\n  background: var(--amber-600);\r\n}\r\n\r\n.db-rack-bar.is-critical i {\r\n  background: var(--red-600);\r\n}\r\n\r\n.db-rack-pct {\r\n  font-size: 0.8rem;\r\n  font-weight: var(--fw-semibold);\r\n  text-align: right;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.db-rack-pct em {\r\n  display: block;\r\n  font-style: normal;\r\n  font-size: 0.7rem;\r\n  font-weight: 400;\r\n  color: var(--text-muted);\r\n}\r\n\r\n/* ── Direccionamiento IP ────────────────────────────────────────────────── */\r\n\r\n.db-ipam-figure {\r\n  display: flex;\r\n  align-items: baseline;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.db-ipam-value {\r\n  font-size: 2rem;\r\n  font-weight: var(--fw-bold);\r\n  line-height: 1;\r\n  color: var(--accent);\r\n}\r\n\r\n.db-ipam-value.is-critical {\r\n  color: var(--red-600);\r\n}\r\n\r\n.db-ipam-caption {\r\n  font-size: 0.8rem;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.db-ipam-bar {\r\n  display: block;\r\n  height: 8px;\r\n  margin: 0.6rem 0 0.9rem;\r\n  border-radius: 999px;\r\n  background: var(--bg-input);\r\n  overflow: hidden;\r\n}\r\n\r\n.db-ipam-bar i {\r\n  display: block;\r\n  height: 100%;\r\n  border-radius: 999px;\r\n  background: rgba(var(--accent-rgb), 0.75);\r\n}\r\n\r\n.db-ipam-bar i.is-critical {\r\n  background: var(--red-600);\r\n}\r\n\r\n.db-ipam-facts {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  gap: 0.5rem;\r\n}\r\n\r\n.db-ipam-facts button {\r\n  display: flex;\r\n  align-items: baseline;\r\n  gap: 0.35rem;\r\n  padding: 0.45rem 0.6rem;\r\n  border: 1px solid var(--border);\r\n  border-radius: var(--radius-lg);\r\n  background: var(--bg-toolbar);\r\n  color: var(--text-secondary);\r\n  font-family: inherit;\r\n  font-size: 0.78rem;\r\n  cursor: pointer;\r\n  transition: border-color 0.15s ease, color 0.15s ease;\r\n}\r\n\r\n.db-ipam-facts button:hover {\r\n  border-color: rgba(var(--accent-rgb), 0.45);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.db-ipam-facts b {\r\n  font-size: 1rem;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.db-ipam-alert {\r\n  margin: 0.8rem 0 0;\r\n  padding: 0.55rem 0.7rem;\r\n  border: 1px solid rgba(220, 38, 38, 0.3);\r\n  border-radius: var(--radius-lg);\r\n  background: rgba(220, 38, 38, 0.1);\r\n  color: var(--text-secondary);\r\n  font-size: 0.8rem;\r\n  line-height: 1.45;\r\n}\r\n\r\n/* ── Hero del inicio + pestañas (2026-10-30) ───────────────────────────────\r\n   El dashboard era una cabecera de texto y tres cajas. Ahora la cabecera es\r\n   una banda con degradado suave, un eyebrow y chips con el inventario, y\r\n   debajo dos pestañas: «Resumen» (lo que hay) y «Seguridad» (cómo está). */\r\n\r\n.dashboard-header--hero {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  gap: 1rem;\r\n  flex-wrap: wrap;\r\n  padding: 1.35rem 1.5rem;\r\n  margin-bottom: 1rem;\r\n  border: 1px solid var(--border);\r\n  border-radius: var(--radius-lg, 16px);\r\n  border-bottom: 1px solid var(--border);\r\n  background:\r\n    radial-gradient(120% 160% at 0% 0%, rgba(var(--accent-rgb, 59, 130, 246), 0.16), transparent 62%),\r\n    radial-gradient(90% 120% at 100% 0%, rgba(139, 92, 246, 0.12), transparent 60%),\r\n    var(--bg-surface);\r\n}\r\n\r\n.dashboard-eyebrow {\r\n  margin: 0 0 0.2rem;\r\n  font-size: 0.7rem;\r\n  font-weight: 700;\r\n  letter-spacing: 0.12em;\r\n  text-transform: uppercase;\r\n  color: var(--accent-l);\r\n}\r\n\r\n.dashboard-header--hero .dashboard-title {\r\n  font-size: 2rem;\r\n  margin: 0 0 0.25rem;\r\n}\r\n\r\n.dashboard-hero-chips {\r\n  display: flex;\r\n  gap: 0.45rem;\r\n  flex-wrap: wrap;\r\n  margin-top: 0.7rem;\r\n}\r\n\r\n.db-tabs {\r\n  display: flex;\r\n  gap: 0.35rem;\r\n  margin: 0 0 1.25rem;\r\n  padding: 0.25rem;\r\n  width: fit-content;\r\n  border: 1px solid var(--border);\r\n  border-radius: 999px;\r\n  background: var(--bg-surface);\r\n}\r\n\r\n.db-tab {\r\n  border: 0;\r\n  background: transparent;\r\n  color: var(--text-secondary);\r\n  font-size: 0.86rem;\r\n  font-weight: 600;\r\n  padding: 0.42rem 1.1rem;\r\n  border-radius: 999px;\r\n  cursor: pointer;\r\n  transition: background 0.15s ease, color 0.15s ease;\r\n}\r\n\r\n.db-tab:hover {\r\n  color: var(--text-primary);\r\n}\r\n\r\n.db-tab.is-active {\r\n  background: var(--accent);\r\n  color: var(--accent-contrast, #fff);\r\n}\r\n\r\n@media (max-width: 720px) {\r\n  .dashboard-header--hero { padding: 1rem; }\r\n  .dashboard-header--hero .dashboard-title { font-size: 1.6rem; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
